import { render, staticRenderFns } from "./UserRecycleBinModal.vue?vue&type=template&id=c07b7d64&scoped=true&"
import script from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"
export * from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07b7d64",
  null
  
)

export default component.exports